<template>
  <div :class="ie ? 'categories ie' : 'categories'">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-tabs v-model="search.category" @input="$emit('change')">
      <b-tab-item v-for="(category, i) in CategoriesList" :key="i" :label="category.name"> </b-tab-item>
    </b-tabs>
    <!-- <div class="categories-tabs">
         <div class="categories-tabs__overlay">
            <div class="categories-tabs__tab"
               :class="search.category === category.id ? 'is-active' : ''"
               v-for="(category, i) in CategoriesList" 
               :key="i"
               @click="search.category = category.id; $emit('change')"
            >{{ category.name }}</div>
         </div>
         <div class="categories-tabs__border"></div>
      </div> -->
    <b-field type="is-info" v-if="!ie">
      <b-select v-model="search.category" @input="$emit('change')" placeholder="Категория 1">
        <option :value="0">Категория</option>
        <option v-for="(category, i) in CategoriesList" :key="i" :value="i">{{ category.name }}</option>
      </b-select>
    </b-field>
    <div class="swiper-container">
      <div id="category-wrapper" class="swiper-wrapper">
        <CategoryItem
          v-for="(course, i) in CoursesList"
          :key="i"
          @click="(courseId) => $emit('open', courseId)"
          :course-info="course"
        />
      </div>
    </div>

    <div v-if="!ie" :style="{ display: isButtonShow() ? 'block' : 'none' }" class="swiper-button swiper-button-prev">
      <i class="icon-button-arrow"></i>
    </div>
    <div v-if="!ie" :style="{ display: isButtonShow() ? 'block' : 'none' }" class="swiper-button swiper-button-next">
      <i class="icon-button-arrow"></i>
    </div>
  </div>
</template>

<script>
import CategoryItem from '@/components/home/CategoryItem'

export default {
  name: 'Categories',
  components: {
    CategoryItem
  },
  props: {
    ie: {
      default: () => false,
      type: Boolean
    },
    isLoading: {
      default: () => false,
      type: Boolean
    },
    search: {
      default: () => {},
      type: Object
    },
    CategoriesList: {
      default: () => [],
      type: Array
    },
    CoursesList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      deviceWidth: 1920
    }
  },
  mounted() {
    this.deviceWidth = window.innerWidth
    window.onresize = () => {
      this.deviceWidth = window.innerWidth
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    isButtonShow() {
      if (this.CoursesList.length < this.deviceWidth / 280) {
        return false
      }
      return true
    }
  }
}
</script>
